import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon, MailIcon, PhoneIcon } from 'lucide-react';
const contactMethods = [{
  icon: MessageSquareIcon,
  title: 'Live Support',
  content: 'Chat instant în platformă',
  color: 'from-blue-500 to-blue-600',
  clickable: false
}, {
  icon: MailIcon,
  title: 'Email Support',
  content: 'office@cautlocuinta.ro',
  color: 'from-purple-500 to-purple-600',
  clickable: true,
  action: () => window.location.href = 'mailto:office@cautlocuinta.ro'
}, {
  icon: PhoneIcon,
  title: 'WhatsApp Business',
  content: '+40 733 355 359',
  color: 'from-green-500 to-green-600',
  clickable: true,
  action: () => window.open('https://wa.me/40733355359', '_blank')
}];
export function ContactSupport() {
  return <section data-id="element-678">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-679">
        <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-4" data-id="element-680">
          Contact & Suport Uman
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-681">
          Ai nevoie de ajutor direct? Echipa noastră este disponibilă zilnic
          pentru asistență umană.
        </p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-682">
        {contactMethods.map((method, index) => <motion.div key={method.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} whileHover={{
        y: -8
      }} onClick={method.clickable ? method.action : undefined} className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all text-center ${method.clickable ? 'cursor-pointer' : ''}`} data-id="element-683">
            <div className={`w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br ${method.color} flex items-center justify-center`} data-id="element-684">
              <method.icon className="w-10 h-10 text-white" data-id="element-685" />
            </div>
            <h3 className="text-xl font-bold text-[#132C53] mb-3" data-id="element-686">
              {method.title}
            </h3>
            <p className="text-[#357BEB] font-semibold text-lg mb-2" data-id="element-687">
              {method.content}
            </p>
          </motion.div>)}
      </div>
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="mt-12 max-w-4xl mx-auto bg-gradient-to-r from-[#21A366] to-[#1a8555] rounded-2xl p-8 text-center text-white" data-id="element-688">
        <p className="text-lg font-medium" data-id="element-689">
          📞 Suport disponibil 7 zile din 7 – prioritate pentru agenți activi
        </p>
      </motion.div>
    </section>;
}